import { CallRouteMappingFilters } from '@reliance/types/filters/CallRouteMappingFilters';
import { Route, RouteMapping } from '@reliance/types/models/Call';
import { useAsync } from 'react-async-hook';
import { IPaginatedResponse } from 'relcore-central';
import api from '../common/api';

export const useCallRoutes = () => {
  return useAsync<IPaginatedResponse<Route>>(
    () => api.get<IPaginatedResponse<Route>>('/call/route').then(r => r.data),
    []
  );
};

export const useCallRouteMappings = (filters?: CallRouteMappingFilters) => {
  return useAsync<IPaginatedResponse<RouteMapping>>(
    () => api.get<IPaginatedResponse<RouteMapping>>('/call/route/mapping', { params: filters }).then(r => r.data),
    [filters]
  );
};
